import CloseIcon from "@mui/icons-material/Close";
import { Box, DialogTitle, IconButton } from "@mui/material";
import { useContext } from "react";

import { PRODUCT_NAME_TOOLKIT } from "@helpers/constants";

import Welcome from "../../../dashboard/components/Welcome";
import { GetStartedContext } from "./GetStartedContext";

function GetStarted() {
  const { toggleDrawer } = useContext(GetStartedContext);

  return (
    <Box sx={{ width: 420, padding: 3 }} role="presentation">
      <DialogTitle sx={{ mt: 1, mb: 2, p: 0 }} id="customized-dialog-title">
        {`Welcome to ${PRODUCT_NAME_TOOLKIT}`}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => toggleDrawer()}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Welcome layout="row" />
    </Box>
  );
}

export { GetStarted };
